<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :label="'name'"
      :name="name"
      :value="optionSelected"
      :options="paginatedValues"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      :filterable="false"
      :clearable="isClearable"
      :placeholder="placeholder"
      @search="onSearch"
      @input="onInput"
      @search:focus="onFocus"
      @close="onClose"
    >
      <template #spinner>
        <b-spinner
          small
          :style="{ opacity: aprovalsState.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        escribe para buscar aprobaciones..
      </template>
      <li v-if="hasNextPage" slot="list-footer" class="pagination">
        <button
          class="btn btn-block btn-primary btn-sm"
          type="button"
          @click="searchPage"
          :disabled="!hasNextPage"
        >
          buscar mas aprobaciones...
        </button>
      </li>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  data() {
    return {
      query: '',
      limit: 10000,
      page: 1,
      pages: 1,
      initial: true
    };
  },
  computed: {
    ...mapGetters('List', ['aprovalsState']),
    isDisabled() {
      return this.disabled;
    },
    optionSelected() {
      return this.aprovalsState.list.find((option) => option.value === this.value);
    },
    hasNextPage() {
      return this.page < Math.max(this.pages, this.filteredPages);
    },
    filteredValues() {
      return this.aprovalsState.list
        .filter(({ label }) => new RegExp(`.*${this.query}.*`, 'i').test(label));
    },
    paginatedValues() {
      return this.filteredValues.slice(0, this.limit * this.page);
    },
    filteredPages() {
      return this.filteredValues.length / this.limit;
    }
  },
  methods: {
    ...mapActions('List', ['fetchAprovals']),
    onInput(event) {
      this.$emit('full-aproval', event);
      this.$emit('input', event?.id);
    },
    onFocus() {
      const selected = this.aprovalsState.list.find((option) => option.value === this.value);
      if (!selected) {
        this.page = 1;
        this.query = '';
        this.debounceFetchAprovals();
      }
    },
    searchPage() {
      this.debounceFetchAprovals({ page: this.page += 1, query: this.query });
    },
    onSearch(query) {
      if (!query) return;
      this.pages = 1;
      this.filtros = query;
      this.debounceFetchAprovals({ query });
    },
    onClose() {
      if (this.value) {
        const selected = this.aprovalsState.list.find((option) => option.value === this.value);
        if (!selected) {
          this.debounceFetchAprovals();
        }
      }
    },
    debounceFetchAprovals: _.debounce(async function debounceFetchAprovals(payload = {}) {
      const filters = [];
      if (payload.query) {
        filters.push(`nombre$${payload.query}`);
      } else if (this.value) {
        filters.push(`id:${this.value}`);
      }
      if (this.reference) {
        filters.push(`tipoObjeto:${this.reference}`);
      }
      if (this.status) {
        filters.push(`aprobacionesEstado:${this.status}`);
      }
      this.initial = false;
      const query = {
        filtros: filters.join('|'),
        pagina: this.page,
        itemsPorPagina: this.limit
      };
      const payloadrequest = { params: query };
      const { totalPaginas } = await this.fetchAprovals(payloadrequest);
      this.pages = totalPaginas;
    }, 350),
    getOption() {
      return this.aprovalsState.list.find((option) => option.value === this.value);
    },
  },
  watch: {
    async parentValue(newValue, oldValue) {
      this.$emit('input', '');
      if (newValue !== oldValue) {
        if (oldValue !== '') {
          this.$emit('input', '');
        }
        await this.searchPage(1);
      }
    }

  },
  props: {
    name: { type: String, required: true },
    placeholder: String,
    label: { type: String, default: 'Aprobaciones' },
    value: { type: String },
    status: { type: String },
    reference: { type: String },
    required: { type: Boolean, default: false },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    isClearable: { type: Boolean, default: true }
  },
  mounted() {
    if (this.value) {
      const selected = this.aprovalsState.list.find((option) => option.value === this.value);
      if (!selected) {
        this.debounceFetchAprovals();
      }
    }
  }
};

</script>
